import React, { useState, useCallback } from 'react';
import parse from 'html-react-parser';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../store/actions/data';

//Bootstrap
import { Container, Row, Col } from 'react-bootstrap';

import HomeCardAbout from '../../../components/HomeCardAbout/HomeCardAbout';
import Products from '../../../components/Products/Products';
import CustomCarousel from '../../../components/CustomCarousel/CustomCarousel';
import Suscribe from '../../../components/Suscribe/Suscribe';

const Inicio = () => {
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const personalInfo = useSelector(state => state.data.personalInfo);
    const imagesPrincipal = useSelector(state => state.data.imagesPrincipal);
    const postsPrincipal = useSelector(state => state.data.posts);
    const typesPosts = useSelector(state => state.data.typesPosts);

    const title = personalInfo ? decodeURIComponent(personalInfo[3].VALOR) : null;
    const description = personalInfo ? parse(decodeURIComponent(personalInfo[0].VALOR)) : null;
    const img = personalInfo ? `./assets/images/${decodeURIComponent(personalInfo[14].VALOR)}` : null;
    const stats1 = {
        value: personalInfo ? parseInt(personalInfo[4].VALOR) : 0,
        label: personalInfo ? decodeURIComponent(personalInfo[4].TITULO_LABEL_HTML) : null
    };
    const stats2 = {
        value: personalInfo ? parseInt(personalInfo[5].VALOR) : 0,
        label: personalInfo ? decodeURIComponent(personalInfo[5].TITULO_LABEL_HTML) : null
    };
    const imagesPrincipalDecode = imagesPrincipal ? imagesPrincipal.map(i => {
        return {
            id: i.ID,
            src: `./assets/images/${decodeURIComponent(i.SRC_IMAGEN)}`,
            title: decodeURIComponent(i.TITULO)
        }
    }) : null;

    const fetchPostsByType = useCallback(async (type) => {
        setError(null);
        try {
            await dispatch(actions.fetchPosts(type, 4));
        } catch (err) {
            setError(err.message);
        }
    }, [dispatch]);

    return (
        <React.Fragment>
            <HomeCardAbout
                title={title}
                description={description}
                img={img}
                stats1={stats1}
                stats2={stats2}
            />
            <hr className="custom-hr" />
            {typesPosts && postsPrincipal && !error ?
                <Products fromHome={true} productTypes={typesPosts} posts={postsPrincipal} fetchPostsByType={fetchPostsByType} />
                :
                <Container fluid className="p-5 text-center custom-text-black">
                    <Row>
                        <Col>
                            <h1 className="font-weight-bolder mb-4">Oops</h1>
                            <h3 className="font-weight-lighter">Algo anda mal :(</h3>
                        </Col>
                    </Row>
                </Container>
            }
            {imagesPrincipalDecode ? <CustomCarousel images={imagesPrincipalDecode} /> : null}
            <Suscribe />
        </React.Fragment>
    );
};

export const componentName = "Inicio";
export default Inicio;